import { createSlice } from '@reduxjs/toolkit';
import { signupUser } from './authAPI';

const initialState = {
  user: null,
  status: '', // idle, loading, succeeded, failed
};

const signupSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem('token'); // Remove token from localStorage on logout
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signupUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        console.log(action.payload)
        state.status = action.payload.message;
        state.user = action.payload.userId
        // state.token = action.payload.token;
        // state.user = action.payload.user;
        // localStorage.setItem('token', action.payload.token); // Save token to localStorage
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { logout } = signupSlice.actions;

export default signupSlice.reducer;
